import React from 'react';
import styles from './PrizeBadgeOverlay.module.css';
import {
  getPrizeTierByKey,
  getPrizeTierByValue,
  IPrizeTier,
} from 'constants/LottoPrizeValues';

export const PrizeBadgeOverlay = (props: { prizeTierCode: string }) => {
  const prizeTier = getPrizeTierByKey(props.prizeTierCode);
  if (!prizeTier) {
    return null;
  }
  return (
    <div
      className={styles.prizeBadgeOverlay}
      style={{ color: prizeTier.color }}
    >
      <img
        className={styles.badge}
        src={prizeTier.badge}
        alt={'Badge for ' + prizeTier.title + ' ' + (prizeTier.subtitle || '')}
      />
      <span className={styles.text}>
        {prizeTier.title}
        <em>{prizeTier.subtitle}</em>
      </span>
    </div>
  );
};
